import React, { useState } from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
} from "@mui/material";
import fade from '../../../../assets/Transition/fade.gif'
import fadeblack from '../../../../assets/Transition/fadeblack.gif'
import fadewhite from '../../../../assets/Transition/fadewhite.gif'
import distance from '../../../../assets/Transition/distance.gif'
import wipeleft from '../../../../assets/Transition/wipeleft.gif'
import wiperight from '../../../../assets/Transition/wiperight.gif'
import wipeup from '../../../../assets/Transition/wipeup.gif'
import wipedown from '../../../../assets/Transition/wipedown.gif'
import slideleft from '../../../../assets/Transition/slideleft.gif'
import slideright from '../../../../assets/Transition/slideright.gif'
import slideup from '../../../../assets/Transition/slideup.gif'
import slidedown from '../../../../assets/Transition/slidedown.gif'
import smoothleft from '../../../../assets/Transition/smoothleft.gif'
import smoothright from '../../../../assets/Transition/smoothright.gif'
import smoothup from '../../../../assets/Transition/smoothup.gif'
import smoothdown from '../../../../assets/Transition/smoothdown.gif'

// Available transitions data
const TRANSITIONS = [
  { id: 0, name: "None", value: "none", color: "#4F46E5",},
  { id: 1, name: "Fade", value: "fade", color: "#4F46E5", img: fade},
  { id: 2, name: "Fadeblack", value: "fadeblack", color: "#7C3AED", img: fadeblack },
  { id: 3, name: "Fadewhite", value: "fadewhite", color: "#EC4899", img: fadewhite },
  { id: 4, name: "Distance", value: "distance", color: "#10B981", img: distance  },
  { id: 5, name: "Wipeleft", value: "wipeleft", color: "#F59E0B", img : wipeleft },
  { id: 6, name: "Wiperight", value: "wiperight", color: "#EF4444", img : wiperight },
  { id: 7, name: "Wipeup", value: "wipeup", color: "#3B82F6", img:wipeup },
  { id: 8, name: "Wipedown", value: "wipedown", color: "#3B82F6", img:wipedown },
  { id: 9, name: "Slideleft", value: "slideleft", color: "#3B82F6", img:slideleft },
  { id: 10, name: "Slideright", value: "slideright", color: "#3B82F6", img:slideright },
  { id: 11, name: "Slideup", value: "slideup", color: "#3B82F6", img:slideup },
  { id: 12, name: "Slidedown", value: "slidedown", color: "#3B82F6", img:slidedown },
  { id: 13, name: "Smoothleft", value: "smoothleft", color: "#3B82F6", img:smoothleft },
  { id: 14, name: "Smoothright", value: "smoothright", color: "#3B82F6", img:smoothright },
  { id: 15, name: "Smoothup", value: "smoothup", color: "#3B82F6", img:smoothup },
  { id: 16, name: "Smoothdown", value: "smoothdown", color: "#3B82F6", img:smoothdown },
];

const Transitions = ({selectedTransition, setSelectedTransition}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleTransitionSelect = (transition) => {
    console.log(`Selected transition: ${transition.value}`);
    setSelectedTransition(transition.value);
    // Here you would typically apply the transition to your video
  };

  return (
    <Box sx={{}}>
        {/* Transition Grid */}
            <Grid container spacing={2}>
              {TRANSITIONS.map((transition) => (
                <Grid item  key={transition.id}>
                  <Card
                    onClick={() => handleTransitionSelect(transition)}
                    sx={{
                      cursor: 'pointer',
                      backgroundColor: selectedTransition.value === transition.value 
                        ? "#2F355F" 
                        : '#2F355F',
                      border: selectedTransition.value === transition.value 
                        ? `1px solid rgba(255, 255, 255, 1)` 
                        : '1px solid rgba(255, 255, 255, 0.30)',
                      borderRadius: '12px',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        backgroundColor: "",
                        transform: 'translateY(-2px)',
                        boxShadow: ``,
                      },
                      height: '100px',
                      width:"130px",
                      p:0.5
                    }}
                  >
                        {/* Animation effect based on transition type */}
                  {transition?.img && <img src={transition?.img} alt={transition?.name} 
                       style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain", // keeps full image visible,
                          borderRadius: '12px',
                        }}/>
                  }
                  </Card>
                   <Typography
                        variant="body2"
                        sx={{
                          color: selectedTransition.value === transition.value 
                            ? 'rgba(255, 255, 255, 1)'
                            : 'rgba(255, 255, 255, 0.7)',
                          fontWeight: selectedTransition.value === transition.value ? 600 : 400,
                          fontSize: '14px',
                          fontFamily: 'Inter',
                          transition: 'all 0.3s ease',
                          mt:1,
                          display:"flex",
                          justifyContent:"center"
                        }}
                      >
                        {transition.name}
                      </Typography>
                </Grid>
              ))}
            </Grid>
    </Box>
  );
}

export default Transitions